import { DISCOUNTS, PRICE_PROMOTION_GROUPS, getDiscountType, formatPrice } from 'chemistry'
import { removeHTMLTags } from 'common/utils'
import { getEqualBannerTitleByType } from './getEqualBannerTitleByType'

export const getEqualBannerTitleDescription = (promotion, t) => {
  const discountType = getDiscountType(promotion)
  const title = getEqualBannerTitleByType(discountType, promotion, t)
  const description = []

  const { isTarget, isQualified, sameProducts } = promotion || {}
  const isCombinedProduct = isTarget && isQualified && !sameProducts

  if (isCombinedProduct) {
    description.push(t('meerdere_combinaties_mogelijk'))
  }

  if (DISCOUNTS.FREE === discountType) {
    description.push(t('cheapest_free'))
  }

  return { title: removeHTMLTags(title), description: removeHTMLTags(description.join(' ')) }
}

export const getQualifiedBannerTitle = ({
  discountType,
  amount,
  loyalty,
  targetName,
  isMultiTarget,
  productName,
  t
}) => {
  let title
  // free discount
  if (discountType === DISCOUNTS.FREE) {
    if (isMultiTarget) {
      title = t('unequal_pdp_free_discount_multi_products_title')
    } else {
      title = t('unequal_pdp_free_discount_single_product_title', { name: targetName })
    }
    title += loyalty
  } // percentage discount
  else if (isMultiTarget) {
    title = t('unequal_pdp_percentage_discount_multi_product_title', { amount })
    title += loyalty
  } else {
    title = t('unequal_pdp_percentage_discount_single_product_title', {
      name: targetName,
      current: productName,
      amount,
      loyalty
    })
  }
  return removeHTMLTags(title)
}

export const getTargetBannerTitle = ({ discountType, amount, loyalty, productName, t }) => {
  // free discount
  if (discountType === DISCOUNTS.FREE) {
    return removeHTMLTags(`${t('unequal_pdp_free_target_discount_product_title', { amount })}${loyalty}`)
  }
  // percentage discount
  return removeHTMLTags(
    t('unequal_pdp_percentage_target_discount_product_title', {
      amount,
      product: productName,
      loyalty
    })
  )
}

const {
  PERCENTAGE_DISCOUNT,
  PERCENTAGE_DISCOUNT_LOYALTY,
  FIXED_DISCOUNT,
  FIXED_DISCOUNT_LOYALTY,
  FIXED_PRICE,
  FIXED_PRICE_LOYALTY,
  ABOVE_CART_PRICE,
  ABOVE_CART_PRICE_LOYALTY,
  ABOVE_PRODUCT_PRICE,
  ABOVE_PRODUCT_PRICE_LOYALTY
} = PRICE_PROMOTION_GROUPS

export const PRICE_PROMOTION_TITLE_TRANSLATIONS = {
  [PERCENTAGE_DISCOUNT]: 'promotions.percentage_discount.title',
  [PERCENTAGE_DISCOUNT_LOYALTY]: 'promotions.percentage_discount_loyalty.title',
  [FIXED_DISCOUNT]: 'promotions.fixed_discount.title',
  [FIXED_DISCOUNT_LOYALTY]: 'promotions.fixed_discount_loyalty.title',
  [FIXED_PRICE]: 'promotions.fixed_price.title',
  [FIXED_PRICE_LOYALTY]: 'promotions.fixed_price_loyalty.title',
  [ABOVE_CART_PRICE]: 'promotions.above_cart_price.title',
  [ABOVE_CART_PRICE_LOYALTY]: 'promotions.above_cart_price_loyalty.title',
  [ABOVE_PRODUCT_PRICE]: 'promotions.above_product_price.title',
  [ABOVE_PRODUCT_PRICE_LOYALTY]: 'promotions.above_product_price_loyalty.title'
}

export const PRICE_PROMOTION_DESCRIPTION_TRANSLATIONS = {
  [ABOVE_CART_PRICE]: 'promotions.above_cart_price.description',
  [ABOVE_CART_PRICE_LOYALTY]: 'promotions.above_cart_price.description',
  [ABOVE_PRODUCT_PRICE]: 'promotions.above_product_price.description',
  [ABOVE_PRODUCT_PRICE_LOYALTY]: 'promotions.above_product_price.description'
}

const PERCENTAGE_PROMOTIONS = [
  PERCENTAGE_DISCOUNT,
  PERCENTAGE_DISCOUNT_LOYALTY,
  ABOVE_CART_PRICE,
  ABOVE_CART_PRICE_LOYALTY,
  ABOVE_PRODUCT_PRICE,
  ABOVE_PRODUCT_PRICE_LOYALTY
]
const getPricePromotionTitleTranslationVariables = ({ promotionGroup, percentage, discountValue, promoPrice } = {}) => {
  if (PERCENTAGE_PROMOTIONS.includes(promotionGroup)) {
    return { percentage }
  }
  if ([FIXED_DISCOUNT, FIXED_DISCOUNT_LOYALTY].includes(promotionGroup)) {
    return { discountValue: formatPrice(discountValue) }
  }
  if ([FIXED_PRICE, FIXED_PRICE_LOYALTY].includes(promotionGroup)) {
    return { price: formatPrice(promoPrice) }
  }
}

export const getPricePromotionTitle = (promotion, t) => {
  const promotionTranslation = PRICE_PROMOTION_TITLE_TRANSLATIONS[promotion?.promotionGroup]
  if (!promotionTranslation) return ''
  return removeHTMLTags(t(promotionTranslation, getPricePromotionTitleTranslationVariables(promotion)))
}

export const getPricePromotionDescription = ({ promotionGroup, priceThreshold } = {}, t) => {
  const promotionDescriptionTranslation = PRICE_PROMOTION_DESCRIPTION_TRANSLATIONS[promotionGroup]
  if (!promotionDescriptionTranslation || !priceThreshold) return ''
  return removeHTMLTags(t(promotionDescriptionTranslation, { priceThreshold: formatPrice(priceThreshold) }))
}

export const getPricePromotionTitleDescription = (promotion, t) => ({
  title: getPricePromotionTitle(promotion, t),
  description: getPricePromotionDescription(promotion, t)
})
